import PropTypes from 'prop-types';
import { attr, Model } from 'redux-orm';

class DashboardV2Task extends Model {
  static modelName = 'DashboardV2Task';

  static fields = {
    id: attr(),
    patientId: attr(),
    patient: attr(),
    typeId: attr(),
    reasonId: attr(),
    createdBy: attr(),
    updatedBy: attr(),
    updatedAt: attr(),
    departmentAthenaId: attr(),
    workflowInstanceId: attr(),
    title: attr(),
    taskDescription: attr(),
    assessmentType: attr(),
    assessmentVariant: attr(),
    caregiverAssisted: attr(),
    caption: attr(),
    status: attr(),
    priority: attr(),
    team: attr(),
    owner: attr(),
    role: attr(),
    pathway: attr(),
    phase: attr(),
    protocol: attr(),
    mustHave2026: attr(),
    due: attr(),
    taskAssignDueAt: attr(),
    noteUrl: attr(),
    taskSop: attr(),
    threadId: attr(),
    isRead: attr(),
    externalObjectType: attr(),
    externalObjectId: attr(),
    parentTaskId: attr(),
    isSubtask: attr(),
    evidence: attr(),
    callbackStatus: attr(),
    blockedBy: attr(),
    blockedAt: attr(),
    blockedStatus: attr(),
    blockedReason: attr(),
    escalatedBy: attr(),
    escalatedAt: attr(),
    escalatedStatus: attr(),
    escalatedTo: attr(),
    escalatedToUser: attr(),
    unblockedBy: attr(),
    unblockedAt: attr(),
    deescalatedBy: attr(),
    deescalatedAt: attr(),
    escalatedReason: attr(),
    isVisible: attr(),
    stateName: attr(),
    stepType: attr(),
    dependency: attr(),
    isFollowing: attr(),
    followedBy: attr(),
  };

  static schema = {
    _fields: PropTypes.exact({
      id: PropTypes.string,
      patientId: PropTypes.number,
      patient: PropTypes.object,
      typeId: PropTypes.number,
      reasonId: PropTypes.number,
      createdBy: PropTypes.number,
      updatedBy: PropTypes.number,
      updatedAt: PropTypes.string,
      departmentAthenaId: PropTypes.string,
      workflowInstanceId: PropTypes.string,
      title: PropTypes.string,
      taskDescription: PropTypes.string,
      assessmentType: PropTypes.string,
      assessmentVariant: PropTypes.string,
      caregiverAssisted: PropTypes.bool,
      caption: PropTypes.string,
      status: PropTypes.number,
      priority: PropTypes.string,
      team: PropTypes.string,
      owner: PropTypes.string,
      role: PropTypes.string,
      pathway: PropTypes.string,
      phase: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      protocol: PropTypes.string,
      mustHave2026: PropTypes.bool,
      due: PropTypes.string,
      taskAssignDueAt: PropTypes.string,
      noteUrl: PropTypes.string,
      taskSop: PropTypes.string,
      threadId: PropTypes.string,
      isRead: PropTypes.bool,
      externalObjectType: PropTypes.string,
      externalObjectId: PropTypes.string,
      parentTaskId: PropTypes.string,
      isSubtask: PropTypes.bool,
      evidence: PropTypes.object,
      callbackStatus: PropTypes.string,
      blockedBy: PropTypes.number,
      blockedAt: PropTypes.string,
      blockedStatus: PropTypes.number,
      blockedReason: PropTypes.number,
      escalatedBy: PropTypes.number,
      escalatedAt: PropTypes.string,
      escalatedStatus: PropTypes.number,
      escalatedTo: PropTypes.number,
      escalatedToUser: PropTypes.number,
      unblockedBy: PropTypes.number,
      unblockedAt: PropTypes.string,
      deescalatedBy: PropTypes.number,
      deescalatedAt: PropTypes.string,
      escalatedReason: PropTypes.string,
      isVisible: PropTypes.bool,
      stateName: PropTypes.string,
      stepType: PropTypes.string,
      dependency: PropTypes.object,
      isFollowing: PropTypes.bool,
      followedBy: PropTypes.arrayOf(PropTypes.number),
    }),
  };
}

export default DashboardV2Task;
